import { doc, onSnapshot } from 'firebase/firestore';
import { useContext, useEffect, useState } from 'react';
import { ACTIVE_TOURNAMENT } from '@/constants';
import { FirebaseContext } from '@/session/FirebaseContext';
import type { MatchdayConfig } from '@/models/scoring';

/** Live tournament MatchDay config from `competitions/{tournament}`. */
export function useMatchdayConfig(): MatchdayConfig | undefined {
  const ctx = useContext(FirebaseContext);
  const [config, setConfig] = useState<MatchdayConfig>();

  useEffect(() => {
    return onSnapshot(doc(ctx.db, 'competitions', ACTIVE_TOURNAMENT), (snapshot) => {
      setConfig(snapshot.exists() ? (snapshot.data() as MatchdayConfig) : undefined);
    });
  }, [ctx.db]);

  return config;
}
